import MonthlyTypeEnum from "../enum/monthly-type-enum";

export abstract class MonthlyDataHelper{
  public static getDataByMontlyType = (element: any, monthlyType: MonthlyTypeEnum) => {
    if (monthlyType == MonthlyTypeEnum.Default){
      return element.trainContactHours;
    }
    else if (monthlyType == MonthlyTypeEnum.NonEscWorksData){
      return element.nonEscWorksData;
    }
    else{
      return element.escWorksDashboardData;
    }
  }

  public static isSumEqual = (allData: any[], month: string,  year: string, 
    nonEscWorksValue: any, escWorksDashboardValue: any = null, submittedValue: any = null) : boolean => 
  {
    const isParsed = MonthlyDataHelper.tryParseFloat(nonEscWorksValue);
    if (!isParsed){
      return true;
    }

    const floatNonEscWorksValue: number = isParsed.parsedValue;
    let floatEscWorksDashBoardValue: number;
    let floatSubmittedValue: number;
    if (escWorksDashboardValue != null) {
      floatEscWorksDashBoardValue = MonthlyDataHelper.tryParseFloat(escWorksDashboardValue).parsedValue;
      floatSubmittedValue = MonthlyDataHelper.tryParseFloat(submittedValue).parsedValue;
    }
    else{
      const monthData = allData.find(element => element.year === year && element.month == month);
      floatEscWorksDashBoardValue = MonthlyDataHelper.tryParseFloat(monthData.escWorksDashboardData).parsedValue;
      floatSubmittedValue = MonthlyDataHelper.tryParseFloat(monthData.trainContactHours).parsedValue;
    }

    return  floatNonEscWorksValue + floatEscWorksDashBoardValue == floatSubmittedValue;
  }

  public static tryParseFloat = (val: string) => {
    if (val === undefined || val === null){
      return {
        isFloat: true,
        parsedValue: 0 
      };;
    }

    let result = {
      isFloat: false,
      parsedValue: 0 
    };

    const floatRegex = /^-?\d+(?:[.,]\d*?)?$/;
    if (!floatRegex.test(val)){
      return result;
    }

    var floatVal = parseFloat(val);
    if (isNaN(floatVal)){
      return result;
    }

    result.isFloat = true;
    result.parsedValue = floatVal;

    return result;
  }
}